import type {
  ReactElement,
  ReactNode,
} from 'react';

import styled from 'styled-components';

export const StyledCounter = styled.span<{
  $isLight: boolean;
  $isError: boolean;
}>(({
  $isLight,
  $isError,

  theme: {
    colors,
    fonts,
  },
}) => ({
  ...fonts.FONT_SMALL,
  lineHeight: '14px',
  display: 'inline-block',
  verticalAlign: 'top',
  backgroundColor: $isError
    ? colors.SUPPORT_ERROR_INVERSE
    : $isLight ? colors.ACTION_BACKGROUND : colors.ACTION_DEFAULT,
  color: $isError
    ? colors.NEUTRAL_WHITE
    : $isLight ? colors.NEUTRAL_SECONDARY : colors.NEUTRAL_WHITE,
  borderRadius: 4,
  paddingLeft: 3,
  paddingRight: 3,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: $isError
    ? colors.SUPPORT_ERROR_INVERSE
    : $isLight ? colors.ACTION_BACKGROUND : colors.ACTION_DEFAULT,
}));

export type CounterProps = {
  /**
   * Значение счётчика
   */
  counter: number;
  /**
   * Максимальное значение счётчика
   */
  maxNumber?: number;
  /**
   * Отображение в светлых цветах
   */
  isLight?: boolean;
  /**
   * Отображение в цвете ошибка
   */
  isError?: boolean;
};

export function Counter({
  counter,
  maxNumber = undefined,
  isLight = false,
  isError = false,
}: CounterProps): ReactElement {
  let content: ReactNode;
  if (typeof maxNumber === 'number') {
    if (counter <= maxNumber) {
      content = counter;
    } else {
      content = `${maxNumber}+`;
    }
  } else {
    content = counter;
  }

  return (
    <StyledCounter
      $isLight={isLight}
      $isError={isError}
    >
      {content}
    </StyledCounter>
  );
}
